module.exports = __webpack_public_path__ + "static/media/hw_wayz_logo.8105a834.png";